import React, { PropsWithChildren, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams, useSearchParams } from 'react-router-dom'
import ComponentInitService from '../../service/ComponentInitService'
import { apolloClient } from '../..'
import { setIframeError, setIsLoaded } from '../../reducers/app'
import { ServiceContainer } from '../../service/ServiceContainer'
import QueryService from '../../service/QueryService'
import { RootState } from '../../store'

export const RouteWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  const { id, locale } = useParams()
  const dispatch = useDispatch()
  const [searchParams, setSearchParams] = useSearchParams();
  const isPreview = searchParams.get('preview') === 'true';

  const isIframeOnMeQr = useSelector((state: RootState) => state.appStorage.isIframeOnMeQr);
  const previewState = useSelector((state: RootState) => state.appStorage.preview)
  const loadedPageId = useSelector((state: RootState) => state.appStorage.pageId)

  const pageId = id ? parseInt(id) : locale ? parseInt(locale) : 0
  const isMeQrMenu = ServiceContainer.resolve<QueryService>('QueryService').token
  const queryService = ServiceContainer.resolve<QueryService>('QueryService')

  useEffect(() => {
    if (!pageId) return
    if (loadedPageId && loadedPageId === pageId) return

    ComponentInitService.init(dispatch, pageId, apolloClient).then(() => {
            dispatch(setIsLoaded(true))
        }).catch((reason) => {
            if (queryService.isDevMode) {
                alert(reason)
            } else if (isMeQrMenu) {
                dispatch(setIframeError(true));
            }
        })
  }, [pageId])

  useEffect(() => {
    if(!isIframeOnMeQr && isPreview && previewState){
        const newParams = new URLSearchParams(searchParams);
        newParams.delete('preview');
        setSearchParams(newParams);
    }
  }, [isIframeOnMeQr, isPreview, previewState])

  return <>{children}</>
}
